import { gql } from '@apollo/client';

export const validateForArchiving = gql`
  query validateForArchiving($courseId: ID!) {
    validateForArchiving(courseId: $courseId) {
      archiveDate
      numberOfPlaylists
      isGloballyFeatured
      isValidForArchiving
    }
  }
`;
